import { cn } from '@ai-tutor/ui';
import type { TitleState } from './buildStages';

const NOTE: Record<TitleState, string | null> = {
  writing: 'Naming your lesson…',
  ready: null,
  failed:
    "Couldn't write a title, so your topic stands in. The lesson still builds.",
};

/**
 * The lesson's title above the build steps. While the overview is still
 * writing it, the typed topic stands in, pulsing softly, with "Naming your
 * lesson…" beneath; the generated title replaces it when it lands (the page
 * refetches metadata on that transition). Not a step: nothing waits for it.
 */
export function BuildTitle({
  title,
  state,
}: {
  title: string;
  state: TitleState;
}) {
  const note = NOTE[state];
  return (
    <header className='shrink-0 text-center'>
      <p className='font-mono text-[11px] font-medium uppercase tracking-[0.14em] text-muted-foreground'>
        Your lesson
      </p>
      <p
        key={state === 'ready' ? 'ready' : 'provisional'}
        className={cn(
          'mx-auto mt-1 line-clamp-2 max-w-xl text-balance text-lg font-semibold',
          state === 'writing'
            ? 'animate-pulse text-muted-foreground motion-reduce:animate-none'
            : 'animate-fade-in text-foreground motion-reduce:animate-none'
        )}
      >
        {title || 'Your new lesson'}
      </p>
      {note && (
        <p
          role={state === 'failed' ? 'status' : undefined}
          className='mt-1 text-xs text-muted-foreground'
        >
          {note}
        </p>
      )}
    </header>
  );
}
